import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ThemeService } from './services/theme.service';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private noDarkModeRoutes = ['/signin', '/signup', '/password-reset', '/registration-submitted'];
  private routerSub?: Subscription;

  constructor(private themeService: ThemeService, private router: Router) {}

  ngOnInit(): void {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const isLightOnly = this.noDarkModeRoutes.some(r => event.urlAfterRedirects.startsWith(r));
        if (isLightOnly) {
          this.themeService.forceLightMode();
        } else {
          this.themeService.restoreTheme();
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
